// ui/illegal-play.js: T6 legal-play feedback copy.
//
// When an illegal card is tapped during trick_play, the UI explains WHY
// instead of silently no-oping: "Must follow ♥ Hearts". The lead suit
// is derived from the first trick play with euchre's one wrinkle, the
// left bower (J of the same-color suit) IS trump, so a left-bower lead
// must be followed with trump, not with its printed suit.
//
// Pure: no DOM, no state. The view renders the message; tests pin the
// bower logic.

import { isBower } from '../canvas/cards.js';

const SUIT_SYMBOL = { S: '♠', H: '♥', D: '♦', C: '♣' };
const SUIT_NAME   = { S: 'Spades', H: 'Hearts', D: 'Diamonds', C: 'Clubs' };

/**
 * The suit a follower is actually obligated to, the lead card's printed
 * suit, except a left-bower lead counts as trump.
 *
 * @param {string|null|undefined} leadCardId
 * @param {string|null|undefined} trumpSuit
 * @returns {string|null}
 */
export function effectiveLeadSuit(leadCardId, trumpSuit) {
  if (!leadCardId || leadCardId.length !== 2) return null;
  if (isBower(leadCardId, trumpSuit) === 'left') return trumpSuit ?? null;
  return leadCardId[1];
}

/**
 * Human message for an illegal tap. Symbol AND name (OQ-7: never a
 * color/symbol-only channel, screen readers get the word).
 *
 * Accepts trick_plays as an array OR as the raw Lua-table-as-object
 * shape (`{"1": {...}}`) the wire snapshot uses before
 * normalizeSnapshotShape runs, Object.values orders integer-like keys
 * ascending, so the first value is the lead either way.
 *
 * @param {{trick_plays?: any, trump_suit?: string|null}|null|undefined} snapshot
 * @returns {string}
 */
export function illegalPlayMessage(snapshot) {
  const tp = snapshot?.trick_plays;
  const plays = Array.isArray(tp) ? tp : Object.values(tp || {});
  const lead = plays.length > 0 ? plays[0]?.card_id : null;
  const suit = effectiveLeadSuit(lead, snapshot?.trump_suit ?? null);
  if (!suit || !SUIT_SYMBOL[suit]) return 'You can’t play that card';
  return `Must follow ${SUIT_SYMBOL[suit]} ${SUIT_NAME[suit]}`;
}
